export default __webpack_public_path__ + "static/customers-94a901ceb9598bb352c6072a190a5b97.png";